class CartDiscountCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('.cart-discount__apply');
    this.message = this.querySelector('.cart-discount__message');

    this.button.addEventListener('click', this.applyCode.bind(this));
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.applyCode();
      }
    });
  }

  applyCode() {
    const code = this.input.value.trim();

    if (!code) {
      this.showMessage(window.cartStrings ? window.cartStrings.discountEmpty : 'Please enter a code', true);
      this.input.focus();
      return;
    }

    this.button.setAttribute('aria-busy', 'true');
    this.button.disabled = true;

    const redirectTo = window.location.pathname + window.location.search;
    window.location.href = `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/'}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectTo)}`;
  }

  showMessage(text, isError) {
    if (!this.message) return;
    this.message.textContent = text;
    this.message.hidden = false;
    this.message.classList.toggle('cart-discount__message--error', !!isError);
  }
}

customElements.define('cart-discount-code', CartDiscountCode);
